import styled from '@emotion/styled';
import { Grid } from '@mui/material';
import { Box } from '@mui/system';
import { colors } from 'theme/colors';

export const StyledLicenceWrapper = styled(Grid)`
  background-color: ${colors.gray100};
  border: 1px solid ${colors.gray200};
  border-radius: 4px;
  padding: 20px 20px 20px 32px;
  margin-bottom: 16px;
  row-gap: 12px;
  column-spacing: 12px;
`;

export const StyledPhoto = styled(Grid)`
  display: flex;
  align-items: center;
  background: ${colors.primary25};
  color: ${colors.primary400};
  height: 320px;
  width: 100%;
  max-width: 270px;
`;

export const StyledDivider = styled(Box)`
  width: 100%;
  height: 1px;
  background-color: ${colors.gray300};
  margin: 0 0 16px 0;
`;
